import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { PaperVisibility } from '../contexts/types';
import { AIReviewUsage } from '@/types/subscription';
import { getAIReviewUsage } from '@/lib/api/subscriptions';
import { adminLog, adminError } from '@/lib/utils/admin-logger';

export const useVisibility = () => {
  const { user } = useAuth();
  const [visibility, setVisibility] = useState<PaperVisibility>('public');
  const [aiReviewUsage, setAIReviewUsage] = useState<AIReviewUsage | null>(null);
  
  useEffect(() => {
    const fetchAIReviewUsage = async () => {
      if (!user?.id) return;
      
      try {
        const usage = await getAIReviewUsage(user.id);
        setAIReviewUsage(usage);
        adminLog('AI review usage fetched:', usage);
      } catch (error) {
        adminError('Error fetching AI review usage:', error);
      }
    };
    
    fetchAIReviewUsage();
  }, [user?.id]);
  
  return {
    visibility,
    setVisibility,
    aiReviewUsage
  };
};
